import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { withSizeHOC } from "../HOC/utility/sizeHOC";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { ShowMoreIcon } from "@fidget/common/components/icons/showMoreIcon/showMoreIcon";
import styles from "./limitedList.css";

interface Props extends React.PropsWithChildren<{}> {
  rowHeight: number;
  maxHeight: number;
  size: { height: number; width: number };
  className?: string;
}
const LimitedListComponent = ({ rowHeight, maxHeight, size, className, children }: Props) => {
  const ref = useRef<HTMLDivElement>();
  const [isOpen, setIsOpen] = useState(false);
  const [displayShowMoreButton, setDisplayShowMoreButton] = useState(false);

  const canDisplayShowMoreBtn = () => {
    if (!ref.current) {
      return false;
    }

    if (isOpen) {
      // if open: display if there's at least one row being displayed over allowed max height
      return ref.current.clientHeight >= maxHeight + rowHeight;
    } else {
      // if not open: display if there's at least one hidden row that could be displayed over current height
      return ref.current.scrollHeight >= ref.current.clientHeight + rowHeight;
    }
  };

  useEffect(() => {
    setDisplayShowMoreButton(canDisplayShowMoreBtn());
  }, [size.height, size.width]);

  return (
    <>
      <div
        ref={(e) => (ref.current = e || undefined)}
        className={classNames(styles.container, className, { [styles["is-open"]]: isOpen })}
      >
        {children}
      </div>
      {displayShowMoreButton && (
        <div className={styles["show-more-container"]}>
          <ShowMoreIcon
            text={isOpen ? intl.formatMessage("showLess") : intl.formatMessage("showMore")}
            onClick={() => setIsOpen(!isOpen)}
          />
        </div>
      )}
    </>
  );
};

export const LimitedList = withSizeHOC(LimitedListComponent);
